import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';

export const setRemixThinkingWaitingForInput =
	(isWaitingForInput: boolean): EditorCommand =>
	({ tr }) => {
		tr.setMeta(remixThinkingPluginKey, {
			isWaitingForInput,
		} satisfies RemixThinkingPluginMeta);

		return tr;
	};
